import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../../components/Header";

const ClassroomsPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page classroomsPage">
        <Header />
        <div className="page-header">Main Campus</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Classrooms & Library</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            Offer your students a complete contactless self-service 
            F&B ordering solution that offers an
            intuitive diner-facing order and pay experience.{'\n\n'}

            IG OnDemand allows diners to place and pay
            for orders using their own device – phone, tablet,
            laptop – for pick-up or delivery.{'\n\n'}

            The result is a more seamless experience and 
            enhanced customer service.
          </div>
        </div>

        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Main Campus - Classrooms & Library", "IG OnDemand");
              addFlow("IG OnDemand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
            <img src={IGOnDemand} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}
export default ClassroomsPage;